import { render } from "./TabShare.vue?vue&type=template&id=1ca986b0"
import script from "./TabShare.vue?vue&type=script&lang=js"
export * from "./TabShare.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__